/**
 * The first run's refs: the record's ref to its canvas, and the ids of the
 * published examples its canned runs copy (see `examples.ts`), which the
 * home's starter row offers too. Its own module, with no imports, so the
 * public index can export it without reaching the first run's payload.
 */
export const CANVAS_REF = "first_run:canvas";

/** The stories with a published example; `briefs.ts` names the same five. */
export type ExampleStory = "rove" | "tessel" | "supper" | "brio" | "kumo";

export type Examples = Readonly<Record<ExampleStory, string>>;

/** Production: Cohesive Templates › Onboarding V2 Examples. */
export const PROD_EXAMPLES: Examples = {
  rove: "a0d8b391-49b9-4e2e-87de-403be749eaee",
  tessel: "99a54d19-deeb-4704-a4ea-da21ffce8a55",
  supper: "ca82ad6c-9bc3-4c55-a32f-ddb2bc86d74b",
  brio: "f8847efa-f204-4a4d-8e98-4d49a96854d2",
  kumo: "44eac1e0-ff45-4cec-9b86-a7ee61019a89",
};

/** Dev: Cohesive Templates › Onboarding Examples V2. */
export const DEV_EXAMPLES: Examples = {
  rove: "333d78e0-7d2e-4236-9c10-22d7d3769a09",
  tessel: "c396a604-cf7d-4584-87aa-ab8a20a01784",
  supper: "aed468f1-f809-4750-a7d8-8f2cbf29466d",
  brio: "9d84ef54-d2c5-48b7-a31b-b6ba30f4c636",
  kumo: "6583ec8d-e958-422d-a890-91687d9af5cf",
};

/** The first-run stack: Venchrz › Samples. */
export const STACK_EXAMPLES: Examples = {
  rove: "9e52fddc-ca76-4706-a239-b90b43fba1d6",
  tessel: "f414fbf3-8b4e-402d-b763-f48de20ea61f",
  supper: "ab2646b1-f55c-4e08-b8c3-9fff3ff7a438",
  brio: "9e61dd88-e9b6-435b-a1d4-f330ea69263f",
  kumo: "336808cd-a37e-458c-8b9a-2b97b88fb937",
};

/**
 * The web app names its environments "prod" and "dev", the mobile shell
 * "production" and "development"; anything else is the first-run stack.
 */
export function examplesFor(appEnv: string): Examples {
  if (appEnv === "prod" || appEnv === "production") return PROD_EXAMPLES;
  if (appEnv === "dev" || appEnv === "development") return DEV_EXAMPLES;
  return STACK_EXAMPLES;
}
